import React, { PureComponent } from "react";
import PropTypes from "prop-types";
const uuidv1 = require('uuid/v1');
import { withTranslation } from "react-i18next";

import styles from './style.css';
import canvasRepository from "../../../domain/repositories/CanvasRepository";
import CanvasComponentsCanvasItem from "../canvas-item";

class CanvasComponentsHorizontalBar extends PureComponent {

  static defaultProps = {
    onCanvasSelect: () => {},
  };

  static propTypes = {
    onCanvasSelect: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      canvas: []
    }
  }

  componentDidMount() {
    this._isMounted = true;
    canvasRepository.load()
      .then((response) => { 
        if (this._isMounted) {
          this.setState({ isLoading: false, canvas: response.data });
        }  
      })
      .catch(e => { 
        if (this._isMounted) {
          this.setState({ isLoading: false });
        } 
      });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  renderLabel(canvas) {
    const onCanvasSelect = () => {
      const uiKey = uuidv1();
      const canvasWithKey = { ...canvas, uiKey };
      this.props.onCanvasSelect(canvasWithKey);
    };

    return (
      <button type="button"
              onClick={onCanvasSelect}
              className={styles.touchable}
              key={canvas.id}>
        <CanvasComponentsCanvasItem canvas={canvas} />
      </button>
    );
  }

  render() {
    const { isLoading, canvas } = this.state;

    if (isLoading) {
      return (
        <div className={styles.container}>
          <div style={{ color: '#fff' }}>{this.props.t('loading')}</div>
        </div>
      );
    }

    return (
      <div className={styles.container}>
        <div className={styles.scrollView}>
          {canvas.map((value, index) => this.renderLabel(value, index))}
        </div>
      </div>
    );
  }
}

export default withTranslation('cmp-labels-horizontal-bar')(CanvasComponentsHorizontalBar);